// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"OverviewHeroAnalyst_bgColor__2Tj3c","image":"OverviewHeroAnalyst_image__XfuWm","whiteText":"OverviewHeroAnalyst_whiteText__Dhhbf"};